const setResumeVolunteer = (volunteer) => ({
    type: 'SET_RESUME_VOLUNTEER',
    volunteer,
});

export default setResumeVolunteer;
